import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-cream min-h-[90vh] flex items-center pt-20 pb-16 px-6 md:px-12 lg:px-24 overflow-hidden" data-id="element-51">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start space-y-8" data-id="element-53">
          <div className="inline-flex items-center space-x-2 bg-white px-4 py-2 rounded-full shadow-warm border border-gold/20" data-id="element-54">
            <CheckCircle2Icon className="w-5 h-5 text-sage" data-id="element-55" />
            <span className="text-navy font-medium text-base md:text-lg" data-id="element-56">
              Tu salud, organizada y sin estrés
            </span>
          </div>

          <div className="space-y-4" data-id="element-57">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-navy leading-tight" data-id="element-58">
              Checklist Vital
            </h1>
            <h2 className="text-2xl md:text-3xl font-semibold text-gold" data-id="element-59">
              Medicamentos y Citas Médicas
            </h2>
          </div>

          <p className="text-xl md:text-2xl text-navy/80 leading-relaxed max-w-xl" data-id="element-60">
            Un sistema claro y fácil para anotar, revisar y recordar lo
            importante… sin depender de la memoria.
          </p>

          <div className="flex flex-col w-full sm:w-auto space-y-4 pt-4" data-id="element-61">
            <a href="#comprar" className="inline-flex justify-center items-center bg-navy text-white text-xl font-semibold px-8 py-5 rounded-2xl hover:bg-navy/90 transition-colors shadow-warm-lg hover:shadow-xl transform hover:-translate-y-1 duration-200" data-id="element-62">
              Obtener Mi Checklist Vital →
            </a>
            <p className="text-center sm:text-left text-lg text-navy/60 font-medium" data-id="element-63">
              Formato imprimible • Fácil de usar • Letra grande
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative" data-id="element-64">
          <div className="absolute inset-0 bg-gold/20 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-65"></div>
          <img src="https://cdn.magicpatterns.com/uploads/mTncYG6oZaY9kVEjwfST5W/Checklist_Medicinas_652B_Image.png" alt="Checklist Vital en uso sobre una mesa de madera con un iPad y medicamentos" className="rounded-3xl shadow-2xl w-full object-cover border-4 border-white" data-id="element-66" />
        </motion.div>
      </div>
    </section>;
}